import { IRestClientRequestOptions } from '../RestClientRequestController/RestClientRequestController.types';
import { HttpErrorName, HttpStatusCode } from '../constants';
import { ERROR_NAMES_MAP } from './RestClientHttpError.constants';

export class RestClientHttpError<B = any> extends Error {
  public readonly time: number = new Date().getTime();

  constructor(
    public statusCode: HttpStatusCode,
    public statusText: string = '',
    public requestEndpoint: string = '',
    public requestOptions: IRestClientRequestOptions<B>,
    public responseData: string = '',
    public responseHeaders: Headers | null = null
  ) {
    super(`HTTP Error: ${statusCode} ${statusText}`);
  }

  get name(): string {
    return ERROR_NAMES_MAP[this.statusCode as HttpStatusCode] || HttpErrorName.Unknown;
  }
}
